import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { ALL_USERS } from '../get-all-users';
import { enableUserAPI } from './api';

export function useEnableUser({ onSuccess }) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutate, mutateAsync, isLoading, isSuccess, isError } = useMutation(
    (userId) => enableUserAPI(userId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'genericErrorMessage',
          },
        });
      },
    },
  );

  return {
    mutate,
    mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
}
